export const dfs = (id, blocks) => {
  let block = blocks.find((block) => block.id == id);
  let results = [block.id];
  if (block.nextBlock.length === 0) return results;
  let nextBlockIds = block.nextBlock.map((nextBlock) => nextBlock.blockId);
  for (let nextBlock of nextBlockIds) {
    results = results.concat(dfs(nextBlock, blocks));
  }
  return results;
};

export const reversDfs = (id, blocks) => {
  let block = blocks.find((block) => block.id == id);
  let results = [block.id];
  if (!block.previousBlock) return results;
  results = results.concat(reversDfs(block.previousBlock, blocks));
  return results;
};
